import axios from 'axios'
import { store } from './store'
import { authHeader } from './helpers';

import Vue from 'vue';

export const http = axios.create({
  
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})

//este http2 lo armé para hacer llamados sin cambiar los headers
export const http2 = axios.create({})

http.interceptors.request.use((config) => {

  // Do something before request is sent
  config.store = store
  config.baseURL = store.state.ambiente.url
  config.headers.Authorization = authHeader();
  
  return config
}, (error) => {
  // Do something with request error
  return Promise.reject(error)
})

// Add a response interceptor
http.interceptors.response.use((response) => {
  // Do something with response data

  if(response.data != null)
    if(response.data.Result != null)
      return response.data.Result // devueldo el contenido de data
    else if(response.data.result != null)
      return response.data.result // devueldo el contenido de data
    else
      return response.data // devueldo el contenido de data

  return response
}, (error) => {
  // Do something with response error
  // console.log('intercept', JSON.stringify(error))
  
  Vue.$log.error('error');
  Vue.$log.error(error);
  
  Vue.$log.error('error response');
  Vue.$log.error(error.response);
  //Vue.$log.error(error.response.status);

  
  if(error== 'Error: Network Error'){
    return Promise.reject('Se ha producido un error al conectarse con el servidor. Intente en unos instantes, y si persiste, comuníquese con sistemas.')
  }
  
  if (error.response && error.response.status === 401) { // auth failed
    
    Vue.$log.error('auth failed');
    Vue.$log.error(error.config.url);
    // const myURL = new URL(error.config.url)

    // if (myURL.pathname !== '/logout' && myURL.pathname !== '/auth/otp') {
    if (!error.config.url.includes('logout')  && !error.config.url.includes('auth/otp') ) {
      error.config.store.dispatch('logout', { forced: true })
      return Promise.reject('La sesión ha expirado, debe volver a loguearse.')
    } 
  }

  if(error.response){
    const errorForDisplay = handleErrorMesage(error.response.data)
    return Promise.reject(errorForDisplay)
  }
  
  return Promise.reject(error)
})

function handleErrorMesage(response){
  
    Vue.$log.error(response);
    if(response.ResponseException !== null){
      // Si el error tiene 'data' es porque tiene info de la API

      if(response.ResponseException && response.ResponseException.ValidationErrors)
      {
        Vue.$log.error('ValidationErrors');
        Vue.$log.error(response.ResponseException.ValidationErrors);

        var err = response.ResponseException.ExceptionMessage

        for (let i = 0; i < response.ResponseException.ValidationErrors.length; i++) {
          const validationError = response.ResponseException.ValidationErrors[i];
          err = err + ' / ' + validationError.Message
        }      
        console.log(err)
        return (err);
      }
      else{
        Vue.$log.error('NO ValidationErrors');
        Vue.$log.error(response.ResponseException);
        if(response.ResponseException)
          return (response.ResponseException.ExceptionMessage);
        else
        return (response);
      }        
    }
    else{
       // si no, logueo el error directamente       
       return (response);
      }
  } 

  //este http2 lo armé para hacer llamados sin cambiar los headers
  http2.interceptors.request.use((config) => {
    return config
  }, (error) => {
    // Do something with request error
    return Promise.reject(error)
  })

  http2.interceptors.response.use((response) => {
    // Do something with response data
  
    if(response.data != null)
      if(response.data.Result != null)
        return response.data.Result // devueldo el contenido de data
      else if(response.data.result != null)
        return response.data.result // devueldo el contenido de data
      else
        return response.data // devueldo el contenido de data
  
    return response
  }, (error) => {
    // Do something with response error
    // console.log('intercept', JSON.stringify(error))
    
    console.log('error');
    console.log(error);
    
    console.log('error response');
    console.log(error.createError);
    //Vue.$log.error(error.response.status);
  
    
    if(error== 'Error: Network Error'){
      return Promise.reject('Se ha producido un error al conectarse con el servidor. Intente en unos instantes, y si persiste, comuníquese con sistemas.')
    }
    
    if (error.response && error.response.status === 401) { // auth failed
      
      console.log('auth failed');
      console.log(error.config.url);
    }
  
    if(error.response){
      const errorForDisplay = handleErrorMesage(error.response.data)
      return Promise.reject(errorForDisplay)
    }
    
    return Promise.reject(error)
  })